import type { FaireProductEntity } from "../../entity_types/product";

export const p_7az3pptk5t: FaireProductEntity = {
  token: "p_7az3pptk5t",
  type: "product",
  name: "Green Floral Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/186be142bb6d8160b559a03c6b80003cc64bc08e97a3c0458fc562256165b064.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e8992d3723a66f07e6c3532f2d10f5fe1f95b4fbf25fe2f7469fb9a2da194c7.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:43.959Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
